<template>
  <div id="app">
   <home-header v-show="!(path ==='/insert') "></home-header>
   <router-view/>
        <home-aside v-show="!(path ==='/insert')"></home-aside>
  </div>
</template>

<script>
import HomeHeader  from '@/components/Header.vue'
import HomeAside from '@/components/Footer.vue'
import Comment from '@/components/Comment.vue'
export default {
  data(){
    return {
      path:''
    }
  },
  name: 'App',
  components: {
    HomeHeader,
    HomeAside,
  },
  created(){
    
  },
  mounted(){
    console.log(this.$route);
    this.path= this.$route.path;
    
  },
	  watch:{
            $route(to,from){
                this.path = to.path
            }
        }
}
</script>

<style>
#app {
  height: 100%;
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue